/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/283' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/list`
 */
export interface DataRuleListGetRequest {
  /**
   * 场景Id
   */
  sceneId?: string;
  /**
   * 属性组Id
   */
  dataPropertyGroupId?: string;
  /**
   * 模板名称
   */
  name?: string;
  /**
   * 模板类型
   */
  type?: string;
  /**
   * 模板状态
   */
  status?: string;
}

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/list`
 */
export type DataRuleListGetResponse = {
  /**
   * 模板id
   */
  id?: number;
  /**
   * 模板名称
   */
  name?: string;
  /**
   * 模板状态
   */
  status?: string;
  /**
   * 模板场景id
   */
  sceneId?: number;
  /**
   * 模板属性组Id
   */
  dataPropertyGroupId?: number;
  /**
   * 参数个数
   */
  constants?: number;
  /**
   * 模板类型
   */
  type?: number;
  /**
   * 展示图片
   */
  imageKey?: string;
}[];

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/list`
 */
type ApiDataRuleListGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/283',
    '',
    'http://127.0.0.1',
    '/api/data-rule/list',
    'retdata',
    string,
    'sceneId' | 'dataPropertyGroupId' | 'name' | 'type' | 'status',
    false
  >
>;

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/list`
 */
const apiDataRuleListGetRequestConfig: ApiDataRuleListGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/data-rule/list',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: ['sceneId', 'dataPropertyGroupId', 'name', 'type', 'status'],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiDataRuleListGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock规则管理↗](http://10.50.16.213:40001/project/283/interface/api/cat_2005)
 * @请求头 `GET /api/data-rule/list`
 */
export const apiDataRuleListGet = /*#__PURE__*/ (requestData: DataRuleListGetRequest, ...args: UserRequestRestArgs) => {
  return request<DataRuleListGetResponse>(prepare(apiDataRuleListGetRequestConfig, requestData), ...args);
};

apiDataRuleListGet.requestConfig = apiDataRuleListGetRequestConfig;

/* prettier-ignore-end */
